// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"customize-bundle-for-shp2_productcontent__H2_zS"};